const ROUTE_CONSTANTS = {
  HOME: '/',
}
export {
  ROUTE_CONSTANTS,
}
